// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._18u01b66{margin-left:var(--ds-space-050,4px)}\n._k48pi7a9{font-weight:var(--ds-font-weight-regular,400)}\n._syaz1gjq{color:var(--ds-text-subtle,#44546f)}", ""]);
// Exports
module.exports = exports;
